export const GLOSSARY = {
    prd: {
        term: 'PRD',
        definition: 'Product Requirements Doc. Describes the problem, audience and user stories for a project — the "what and why", written before any technical design.',
    },
    tdd: {
        term: 'TDD',
        definition: 'Technical Design Doc. Describes how the project will be built — architecture, data model, deployment — generated from the PRD plus your answers to a short questionnaire.',
    },
    out_of_scope: {
        term: 'Out of scope items',
        definition: 'Things this project deliberately will not do. Recorded so later requests can be checked against them instead of re-argued.',
    },
    backlog: {
        term: 'Backlog',
        definition: 'Not started and not yet scheduled.',
    },
    on_hold: {
        term: 'On Hold',
        definition: 'Paused deliberately — waiting on a decision or another piece of work, not blocked by an external problem.',
    },
    blocked: {
        term: 'Blocked',
        definition: 'Cannot proceed because of an external problem (an issue). Shown in red and the project lead is notified.',
    },
    in_review: {
        term: 'In Review',
        definition: 'Work is complete and awaiting review before merging or closing.',
    },
    testing: {
        term: 'Testing',
        definition: 'Implementation is done and is being verified.',
    },
    canceled: {
        term: 'Canceled',
        definition: 'No longer needed. Kept for history rather than deleted — often the result of a regeneration marking a task obsolete.',
    },
    dependency: {
        term: 'Dependency',
        definition: 'A task that must be completed, or reach a certain state, before this one can proceed.',
    },
    traceability: {
        term: 'Traceability',
        definition: 'The link from a task back to the TDD section and PRD user story that produced it, so you can see why a task exists.',
    },
    regeneration: {
        term: 'Regeneration',
        definition: 'When the PRD or TDD changes, the LLM proposes which existing tasks are affected, which new tasks are needed, and which are now obsolete. Nothing changes until you accept each proposal.',
    },
    deliverable: {
        term: 'Deliverable',
        definition: 'A tangible output of the project: a screenshot, a live deployment link, a cloud project link, or an attachment.',
    },
    audit_log: {
        term: 'Audit log',
        definition: 'A permanent record of who did what and when — every document version, status change, and validated LLM output.',
    },
    allowlist: {
        term: 'Allowlist',
        definition: 'The list of email domains allowed to sign in to this app. Managed by org owners/admins or via the CLI.',
    },
    self_assign: {
        term: 'Self-assign',
        definition: 'Any project member can claim an unassigned task for themselves; only a lead can assign tasks to other people.',
    },
};
//# sourceMappingURL=glossary.js.map